export type { CulturalObjectHeroProps } from "./cultural-object-hero";
export { CulturalObjectHero } from "./cultural-object-hero";
